import { IN_SLA_PROPERTY_VALUE, BREACHED_PROPERTY_VALUE, SLA_WARNING_PROPERTY_VALUE, RESOLVED_IN_SLA_PROPERTY_VALUE, RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE } from './enums';
/**
 * Tag takes color in the 'use' param. By convention, that param takes color names in lowercase and with dashes
 * between words.
 *
 * This is different from how Icon works, hence the two different maps.
 */
export const SLAStatusToTagColorMap = {
  [IN_SLA_PROPERTY_VALUE]: 'thunderdome',
  [BREACHED_PROPERTY_VALUE]: 'candy-apple',
  [SLA_WARNING_PROPERTY_VALUE]: 'marigold',
  [RESOLVED_IN_SLA_PROPERTY_VALUE]: 'default',
  [RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE]: 'default'
};

// We manually specify these Trellis tokens so we don't have to add a dependency on the Trellis packages

/**
 * Maps SLA statuses to semantic color tokens for icons following Trellis design system
 */
export const SLAStatusToIconColorTokenMap = {
  [IN_SLA_PROPERTY_VALUE]: 'fill-accent-purple-default',
  [BREACHED_PROPERTY_VALUE]: 'fill-accent-red-default',
  [SLA_WARNING_PROPERTY_VALUE]: 'fill-accent-yellow-default',
  [RESOLVED_IN_SLA_PROPERTY_VALUE]: 'fill-positive-default',
  [RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE]: 'fill-accent-yellow-default'
};